import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Validation from './pages/Validation';

function Home() {
  return <h2 className="mt-4">Hello Brick</h2>;
}

function Main() {
  return <a href="https://www.verbaw.com">Main</a>;
}

function App() {
  return (
    <>
      <Navbar />
      <main className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/main" element={<Main />} />
        </Routes>
      </main>
    </>
  );
}

export default App;
